/**
 * Bundled English translations — available synchronously on server and client
 * so SSR/hydrate do not wait on HttpApi. Keep in sync with `I18N_NAMESPACES`
 * and `public/locales/en/*.json`.
 */
import ask from "@/../public/locales/en/ask.json";
import assistants from "@/../public/locales/en/assistants.json";
import calls from "@/../public/locales/en/calls.json";
import campaigns from "@/../public/locales/en/campaigns.json";
import common from "@/../public/locales/en/common.json";
import contacts from "@/../public/locales/en/contacts.json";
import coverages from "@/../public/locales/en/coverages.json";
import dataTable from "@/../public/locales/en/dataTable.json";
import directory from "@/../public/locales/en/directory.json";
import doNotCall from "@/../public/locales/en/doNotCall.json";
import duplicate from "@/../public/locales/en/duplicate.json";
import errors from "@/../public/locales/en/errors.json";
import evals from "@/../public/locales/en/evals.json";
import getGail from "@/../public/locales/en/getGail.json";
import gailUniversity from "@/../public/locales/en/gailUniversity.json";
import inbound from "@/../public/locales/en/inbound.json";
import knowledge from "@/../public/locales/en/knowledge.json";
import loader from "@/../public/locales/en/loader.json";
import login from "@/../public/locales/en/login.json";
import notifications from "@/../public/locales/en/notifications.json";
import onboarding from "@/../public/locales/en/onboarding.json";
import outbound from "@/../public/locales/en/outbound.json";
import partners from "@/../public/locales/en/partners.json";
import permissions from "@/../public/locales/en/permissions.json";
import reporting from "@/../public/locales/en/reporting.json";
import restrictions from "@/../public/locales/en/restrictions.json";
import review from "@/../public/locales/en/review.json";
import routes from "@/../public/locales/en/routes.json";
import scripts from "@/../public/locales/en/scripts.json";
import settings from "@/../public/locales/en/settings.json";
import sites from "@/../public/locales/en/sites.json";
import skills from "@/../public/locales/en/skills.json";
import sms from "@/../public/locales/en/sms.json";
import stats from "@/../public/locales/en/stats.json";
import trialUsage from "@/../public/locales/en/trialUsage.json";
import update from "@/../public/locales/en/update.json";
import validation from "@/../public/locales/en/validation.json";
import voices from "@/../public/locales/en/voices.json";
import workflows from "@/../public/locales/en/workflows.json";

export const enResources = {
  ask,
  assistants,
  calls,
  campaigns,
  common,
  contacts,
  coverages,
  dataTable,
  directory,
  doNotCall,
  duplicate,
  errors,
  evals,
  getGail,
  gailUniversity,
  inbound,
  knowledge,
  loader,
  login,
  notifications,
  onboarding,
  outbound,
  partners,
  permissions,
  reporting,
  restrictions,
  review,
  routes,
  scripts,
  settings,
  sites,
  skills,
  sms,
  stats,
  trialUsage,
  update,
  validation,
  voices,
  workflows,
};
